import { Grid, Spinner } from '@chakra-ui/react'

export default function Loader() {
  return (
    <Grid height='100vh' width='100%' placeItems='center'>
      <Spinner thickness='4px' speed='0.45s' emptyColor='gray.100' color='primaryColor' size='xl' />
    </Grid>
  )
}
